import {isObject, isString} from 'lodash';
import Vue from 'vue';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

function configureBugsnag() {
  if (!window) {
    return;
  }
  const environments = [
    'staging',
    'production',
  ]
  const config = window.config ? window.config : window.ML;
  if (isObject(config) && isString(config.env) && isString(config.bugsnag)) {
    const env = config.env;
    if (environments.includes(env)) {
      window.Bugsnag = Bugsnag;
      const options = {
        releaseStage: env, // @see https://docs.bugsnag.com/platforms/javascript/legacy/restify/configuration-options/#releasestage
        apiKey: config.bugsnag,
        plugins: [new BugsnagPluginVue()],
        appVersion: config.bugsnag_app_version ?? '4.0.0', // MLD-7893
      }
      if (isObject(config.user)) {
        options.user = {
          id: config.user.id,
          email: config.user.email,
          name: config.user.name
        };
      }
      Bugsnag.start(options)
      const bugsnagVue = Bugsnag.getPlugin('vue')
      bugsnagVue.installVueErrorHandler(Vue)
      console.log('Bugsnag is configured.');
    } else {
      console.log(`Bugsnag is disabled in this environment (${env}).`);
    }
  }
}

configureBugsnag();
